import { useAppDispatch, useAppSelector } from '@store/hooks'
import { getPlans, selectPlanById } from '@store/membership/PlanReducer'
import { SBAsyncSelect } from '@supplement-bacon/react-async-select'
import { initialQuery } from '@supplement-bacon/sb-table-filters'
import { SBRMFormActionProps } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import { requiredRule } from '@utils/rules'
import { Form } from 'antd'
import { useEffect } from 'react'
import ContactFields from '../ContactFields'

const Create = ({ form, formProps }: SBRMFormActionProps) => {
  const dispatch = useAppDispatch()
  const planId = Form.useWatch('plan', form)
  const planDetails = useAppSelector(selectPlanById(planId))

  useEffect(() => {
    dispatch(getPlans(initialQuery))
    form.setFieldValue('paymentRequired', false)
  }, [])

  return (
    <Form {...formProps} form={form} layout="vertical">
      <Form.Item name="plan" rules={[requiredRule()]} label={'Plan'}>
        <SBAsyncSelect
          entity={Entity.membershipPlan}
          searchFieldName="name"
          allowClear
        />
      </Form.Item>
      <Form.Item name="coupon" label={'Coupon'}>
        <SBAsyncSelect
          allowClear
          entity={Entity.coupon}
          searchFieldName="code"
        />
      </Form.Item>

      {/* Persons */}
      {Array.from({ length: planDetails?.membersLimit ?? 0 }, (_, i) => (
        <ContactFields key={i} index={i} />
      ))}
    </Form>
  )
}

export default Create
